import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  source: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_SOURCE_BUSY: (state, payload) => {
    state.source.isBusy = payload;
  },
  LOAD_SOURCE_SUCCESS: (state, payload) => {
    state.source.isBusy = false;
    state.source.data = payload;
    state.source.error = null;
  },
  LOAD_SOURCE_FAIL: (state, payload) => {
    state.source.isBusy = false;
    state.source.data = null;
    state.source.error = payload;
  }
};

const getters = {
  sourcesErrors: (state) => {
    return state.source.error;
  }
}

const actions = {
  addSource: ({ commit, rootState }, { projectId, source }) => {
    commit('LOAD_SOURCE_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return new Promise((resolve, reject) => {
      Axios
        .post(`${API_HOST}/analysis/editor/${projectId}/source`, source, config)
          .then(response => {
            commit('LOAD_SOURCE_SUCCESS', response.data)
            resolve();
          })
          .catch(error => {
            const data = error.response.data;

            if (!data.message) {
              Vue.notify({
                group: 'store_notifications',
                type: 'error',
                text: i18n.t('messages.request.error')
              });
            }

            commit('LOAD_SOURCE_FAIL', [data.message ? data.message : data]);
            reject(error.response.data);
          })
    })

  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};